import { preview } from '@/components/form/preview'
import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'

import { useTexts } from '../useTexts'
import { NumberedLabel } from './NumberedLabel'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function DetectedCheckIn(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const autoTimeInSec = extOrder.orderStep.trackingData?.autoTimeInSec ?? -1
  const autoTimeInDisabled = autoTimeInSec === -1

  return (
    <preview.Field
      label={
        <NumberedLabel
          number={3}
          label={texts.detectedCheckIn.label}
          color="#64B5F6"
          disabled={autoTimeInDisabled}
        />
      }
      testId="execution-detected-check-in"
    >
      {autoTimeInSec > 0 ? (
        <ConvertTime seconds={autoTimeInSec} showSeconds={false} />
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
